import React, { createContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import API from '../../../../services/API'

import Loading from '../../../loading/loadingPage'
import EmployeeTabs from './Tabs'
import MiddleStack from './MiddleStack'
import Actions from './Actions'
import StatusChips from './TopPanel/StatusChips'
import ContactLinks from './TopPanel/ContactLinks'

//@MUI
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'
import Modal from '@mui/material/Modal'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import { Button, useTheme } from '@mui/material'
import AmbuNetTheme from '../../../../components/Theme'
import BigModal from '../../../../components/Modals/BigModal'
import EmployeeForm from '../addNewEmployee/EmployeeForm'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import moment from 'moment'
import CheckBox from '@mui/icons-material/CheckBox'
import NotLoggedIn from './Alerts/NotLoggedIn'
import DetailsTab from './detailsTab/Details'
import { DetailRow } from '../../../../components/Cards/DetailsBox'
import OnboardingChecklist from './OnboardingChecklist'
import { useDocumentTitle } from '../../../../helpers/DocumentTitleManager'

export const EmployeeContext = createContext({})

const EmployeeSingle = () => {
  const [loading, setLoading] = useState(true)
  const { userId: dbID } = useParams('')
  const {setPageTitle} = useDocumentTitle()
  const [invalidID, setInvalidID] = useState(false)
  const [employee, setEmployee] = useState({})
  const [editEmployee, setEditEmployee] = useState(false)
  const [openTab, setOpenTab] = useState(0)

  const loadEmployee = () => {
    setLoading(true)
    API.get(`/employees/${dbID}`)
      .then(async (res) => {
        if (res.status === 200) {
          setEmployee(res.data)
        } else {
          setInvalidID(true)
        }
      })
      .catch((e) => {
        setInvalidID(true)
        console.log(e)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (employee?.firstName) {
      setPageTitle(`${employee.firstName} ${employee.lastName}`)
    }
  }, [employee, setPageTitle])

  useEffect(() => {
    if (dbID.length !== 12 && dbID.length !== 24) {
      setInvalidID(true)
    }
    loadEmployee()
  }, [])

  if (loading) {
    return <Loading />
  } else if (invalidID) {
    return <Alert severity="error">Employee Not Found</Alert>
  } else
    return (
      <EmployeeContext.Provider value={{ loadEmployee, openTab, setOpenTab }}>
        <Stack gap={2}>
          <Box padding={3} component={Paper}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={4}
                display="flex"
                flexDirection="column"
                gap={1}
              >
                <Typography variant="title2" fontSize={18}>{`${
                  employee.prefix ?? ''
                } ${employee.firstName ?? ''} ${
                  employee.lastName ?? ''
                }`}</Typography>
                <Typography
                  variant="title2"
                  fontSize={12}
                >{`${employee.employee?.clinicalRole || ''}`}</Typography>
                <StatusChips user={employee} setEmployee={setEmployee} />
                <Stack gap={1}>
                  <DetailRow
                    label="Start Date"
                    value={moment(employee.employee.employmentStartDate).format(
                      'Do MMM YYYY',
                    )}
                    noBorder
                  />
                  {employee.employee.status === 'Leaver' && (
                    <>
                      <DetailRow
                        label="Leave Date"
                        value={moment(
                          employee.employee.employementEndDate,
                        ).format('Do MMM YYYY')}
                        noBorder
                      />
                      <DetailRow
                        label="Reason for Leaving"
                        value={employee.employee.reasonForLeaving}
                        noBorder
                      />
                    </>
                  )}
                </Stack>
                <ContactLinks user={employee} />
              </Grid>
              <MiddleStack
                employee={employee.employee}
                userAccount={employee}
                userID={employee._id}
              />
              <Grid
                item
                xs={12}
                md={4}
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                gap={1}
              >
                <Avatar
                  src={
                    typeof employee.photograph === 'string'
                      ? employee.photograph
                      : null
                  }
                  sx={{
                    borderRadius: 1,
                    width: 128,
                    height: 128,
                    zIndex: 1,
                  }}
                  component={Paper}
                  elevation={4}
                  width={128}
                >
                  {employee?.firstName?.[0] + employee?.lastName?.[0]}
                </Avatar>
                <Actions
                  employeeID={employee._id}
                  employee={employee}
                  setEmployee={setEmployee}
                  setEditEmployee={setEditEmployee}
                />
              </Grid>
            </Grid>
          </Box>
          <NotLoggedIn employee={employee} />
          <OnboardingChecklist
            employee={employee.employee}
            userAccount={employee}
            loadEmployee={loadEmployee}
          />
          {/* <DataBar /> */}
          <Box padding={1} component={Paper}>
            <EmployeeTabs employee={employee} loadEmployee={loadEmployee} />
          </Box>

          <BigModal open={editEmployee} onClose={() => setEditEmployee(false)}>
            <EmployeeForm
              employeeID={employee._id}
              isSelf={false}
              onClose={() => {
                setEditEmployee(false)
                loadEmployee()
              }}
              onImageChange={() => loadEmployee()}
            />
          </BigModal>
        </Stack>
      </EmployeeContext.Provider>
    )
}

export default EmployeeSingle
